var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.1043 44C88.1043 35.9401 85.8905 28.0351 81.7044 21.1475C77.5183 14.26 71.5208 8.65458 64.3664 4.943C57.212 1.23142 49.1755 -0.443724 41.134 0.100372C33.0926 0.644469 25.355 3.3869 18.7658 8.02839C12.1765 12.6699 6.98878 19.0321 3.76864 26.4208C0.548498 33.8094 -0.580309 41.9406 0.505402 49.927C1.59111 57.9134 4.84963 65.4482 9.92535 71.7091C15.0011 77.9699 21.699 82.7164 29.2882 85.4304L35.4402 68.2274C31.0023 66.6403 27.0855 63.8647 24.1173 60.2035C21.1492 56.5423 19.2437 52.1362 18.6088 47.466C17.9739 42.7957 18.634 38.0408 20.517 33.7201C22.4001 29.3994 25.4338 25.6789 29.287 22.9647C33.1402 20.2505 37.6649 18.6468 42.3674 18.3286C47.0698 18.0104 51.7693 18.99 55.9531 21.1604C60.1368 23.3309 63.644 26.6088 66.0919 30.6364C68.5398 34.6641 69.8344 39.2868 69.8344 44H88.1043Z",
    fill: "#64748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3192 85.4415C35.9916 87.822 43.1401 88.5562 50.157 87.5817C57.174 86.6072 63.8519 83.9528 69.623 79.8441C75.3942 75.7354 80.0879 70.294 83.3052 63.9824C86.5225 57.6708 88.1682 50.6757 88.1025 43.5917L69.8334 43.7612C69.8718 47.9038 68.9094 51.9944 67.028 55.6852C65.1466 59.3761 62.4019 62.5581 59.027 64.9607C55.6522 67.3634 51.7472 68.9156 47.6438 69.4855C43.5405 70.0554 39.3602 69.626 35.4584 68.2339L29.3192 85.4415Z",
    fill: "#06B6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.f8dcedd8b0c03346cc832271f3c3335c.svg";
export { ForwardRef as ReactComponent };